import { LitElement } from 'lit-element';

import { isVrootChild } from '@elab/core/utils/webComponent';

export default class LightLitElement extends LitElement {
    createRenderRoot() {
        if (isVrootChild(this)) {
            // Prevent copying slots from slots
            const hasNestedSlots = this.querySelector('v-slot-assigned-content v-root');

            if (!hasNestedSlots) {
                // Extract original slots from component
                const slots = this.querySelectorAll('v-slot-assigned-content > *');
                slots.length && this.append(...slots);
            }

            this.vRoot = this.firstElementChild;
        }

        if (!this.vRoot) {
            this.vRoot = document.createElement('v-root');
        }
        return this.vRoot;
    }

    connectedCallback() {
        super.connectedCallback();
        if (!this.renderRoot.parentElement && this !== this.renderRoot) {
            this.appendChild(this.renderRoot);
        }
    }
}
